import { all, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

import GLOBAL_ERROR_MESSAGE from '@app/constants/errorMessages';
import workspaceService from '@app/libs/workspaceService';
import {
  DOCUMENT_AUDIT_TRAIL__DOWNLOAD_REQUEST,
  DOCUMENT_AUDIT_TRAIL__FETCH_REQUEST,
} from '@app/store/actionTypes';
import {
  downloadAuditTrailFailure,
  downloadAuditTrailSuccess,
  fetchAuditTrail,
  fetchAuditTrailFailure,
  fetchAuditTrailSuccess,
} from '@app/store/document/auditTrailFile/actions';
import { getAuditTrailFile } from '@app/store/document/auditTrailFile/selectors';
import { modalOpen } from '@app/store/modal/actions';
import { getDocumentsAuditTrailFile } from '@app/store/transport-layer/document/documents/audit-trail/file';
import { downloadFileFromURLSaga } from '@app/store/transport-layer/files';

export function* downloadAuditTrailSaga() {
  try {
    const url: ReturnType<typeof getAuditTrailFile> = yield select(getAuditTrailFile);

    if (url) {
      yield call(downloadFileFromURLSaga, {
        url,
        saveFileName: '감사추적인증서.pdf',
      });
      yield put(downloadAuditTrailSuccess());
    } else {
      throw new Error('url is null');
    }
  } catch (error) {
    yield put(downloadAuditTrailFailure(error));
    yield put(
      modalOpen('CONFIRM', {
        title: '감사추적인증서 다운로드 실패',
        content: '예상하지 못한 오류로 인해 다운로드를 실패했습니다.',
      })
    );
  }
}

export function* fetchAuditTrailSaga({
  payload: { documentId },
}: ReturnType<typeof fetchAuditTrail>) {
  try {
    const workspaceId = workspaceService.getWorkspaceId();
    const url: string = yield call(getDocumentsAuditTrailFile, {
      workspaceId,
      documentId,
    });
    yield put(
      fetchAuditTrailSuccess({
        url,
      })
    );
  } catch (error) {
    yield put(fetchAuditTrailFailure(error));
    yield put(
      modalOpen('CONFIRM', {
        title: '문서 파일 다운로드 실패',
        content: GLOBAL_ERROR_MESSAGE[error.message] || error.message,
      })
    );
  }
}

export default function* saga() {
  yield all([
    takeEvery(DOCUMENT_AUDIT_TRAIL__DOWNLOAD_REQUEST, downloadAuditTrailSaga),
    takeLatest(DOCUMENT_AUDIT_TRAIL__FETCH_REQUEST, fetchAuditTrailSaga),
  ]);
}
